// extracted by mini-css-extract-plugin
export default {"charts":"Charts_charts__lJrdp","trisect":"Charts_trisect__CyWpx"};